// extracted by mini-css-extract-plugin
export default {"brand":"brand-module--brand--S0XAS","link":"brand-module--link--H6fI6","icon":"brand-module--icon---ujfF","tagline":"brand-module--tagline--A5bid"};